var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnife(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M3.22 4.522c.337-.142.717-.18.777.543-.145.243-.166.422-.482.318a.085.085 0 0 0-.05.078c.324.433.743-.106.887-.25.813 1.112 1.745 1.917 2.706 2.646.023.14.023.272.079.425a.51.51 0 0 0 .142.055c.433-.203.692-.516.85-.89a.25.25 0 0 0-.102-.15l-.362-.055A14.365 14.365 0 0 0 4.962 4.58c.132-.137.273-.268.38-.42.016-.197-.018-.289-.147-.382-.072.01-.145.064-.152.122.05.077.084.128.045.215a2.184 2.184 0 0 1-.29.126l-.076.063c-.684-.692-1.37-1.359-2.179-2.009C1.991 1.876 1.213 1.066.511.143c-.32 1.84 1.432 3.063 2.708 4.379Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnife);
export default __webpack_public_path__ + "static/media/knife.2ae01738b12970ea305fdea1262c1f65.svg";
export { ForwardRef as ReactComponent };